var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHumidity01 = function SvgHumidity01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Capa 1",
    viewBox: "0 0 512 512",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "humidity-01_svg2__a",
    x1: 69.86,
    x2: 439.86,
    y1: 459.9,
    y2: 87.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#humidity-01_svg2__a",
    id: "humidity-01_svg2__b",
    x1: -111.87,
    x2: 258.13,
    y1: 279.14,
    y2: -92.86
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#humidity-01_svg2__a",
    id: "humidity-01_svg2__c",
    x1: 81.64,
    x2: 451.64,
    y1: 471.62,
    y2: 99.62
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#humidity-01_svg2__a",
    id: "humidity-01_svg2__d",
    x1: 30.06,
    x2: 400.06,
    y1: 420.31,
    y2: 48.31
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#humidity-01_svg2__a",
    id: "humidity-01_svg2__e",
    x1: 134.77,
    x2: 504.77,
    y1: 524.45,
    y2: 152.45
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M506.58 225.09c0-18.91-5.45-37.22-15.77-52.96l-20.39-35c-2.08-3.58-6.68-4.79-10.26-2.71a7.51 7.51 0 0 0-2.71 10.26l20.49 35.18c.07.12.14.23.21.35 8.77 13.33 13.41 28.86 13.41 44.89 0 21.85-8.51 42.4-23.97 57.85-15.45 15.43-35.97 23.93-57.8 23.93h-.07c-45.05-.04-81.71-36.72-81.71-81.78 0-16.04 4.64-31.56 13.41-44.89.08-.11.15-.23.21-.35l68.15-116.98 29.97 51.44c2.08 3.58 6.68 4.79 10.26 2.71a7.51 7.51 0 0 0 2.71-10.26l-31.44-53.96c-2.41-4.14-6.71-6.61-11.49-6.6s-9.08 2.47-11.49 6.61l-58.65 100.67L255.62 9.22C252.26 3.45 246.26 0 239.58 0s-12.67 3.45-16.04 9.22L90.91 236.88c-19 28.95-29.05 62.62-29.05 97.4 0 41.15 14.4 81.28 40.55 112.99a7.48 7.48 0 0 0 5.79 2.73 7.494 7.494 0 0 0 5.78-12.27c-23.94-29.03-37.13-65.76-37.13-103.44 0-31.91 9.23-62.8 26.69-89.33.08-.11.15-.23.22-.35L236.51 16.77c.9-1.54 2.31-1.77 3.08-1.77s2.18.23 3.08 1.77l88.32 151.6-2.19 3.76c-10.32 15.75-15.77 34.06-15.77 52.96 0 50.65 39.14 92.36 88.77 96.45.33 4.24.51 8.5.51 12.75 0 43.49-16.94 84.37-47.7 115.1C323.88 480.1 283.04 497 239.6 497h-.14c-37.12-.03-73.43-12.9-102.23-36.24-3.22-2.61-7.94-2.11-10.55 1.1-2.61 3.22-2.11 7.94 1.1 10.55 31.46 25.5 71.11 39.56 111.66 39.59h.15c47.44 0 92.05-18.47 125.61-52 33.6-33.57 52.1-78.22 52.1-125.71 0-4.22-.17-8.45-.46-12.67 23.19-1.66 44.76-11.47 61.37-28.07 18.3-18.28 28.37-42.59 28.37-68.46",
    style: {
      fill: "url(#humidity-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.99 117.89c0-10.87-3.13-21.39-9.04-30.45L70.4 22.97c-1.9-3.26-5.42-5.28-9.19-5.28s-7.29 2.02-9.19 5.28L14.46 87.43c-5.92 9.06-9.04 19.59-9.04 30.45 0 30.74 25 55.76 55.74 55.79h.05c14.89 0 28.9-5.8 39.43-16.32 10.55-10.54 16.35-24.55 16.35-39.46m-55.78 40.78h-.03c-22.47-.02-40.75-18.31-40.75-40.78 0-8 2.31-15.74 6.69-22.39.08-.11.15-.23.22-.35l33.88-58.16L95.1 95.15c.07.12.14.23.22.35a40.66 40.66 0 0 1 6.69 22.39c0 10.9-4.25 21.15-11.96 28.85-7.7 7.7-17.94 11.93-28.83 11.93Z",
    style: {
      fill: "url(#humidity-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.92 221.83c-3.82-1.6-8.22.19-9.82 4.01l-70.36 167.64c-1.6 3.82.19 8.22 4.01 9.82.95.4 1.93.59 2.9.59 2.93 0 5.71-1.73 6.92-4.6l70.36-167.64c1.6-3.82-.19-8.22-4.01-9.82",
    style: {
      fill: "url(#humidity-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.44 213.43c-21.28 0-38.59 19.57-38.59 43.62s17.31 43.63 38.59 43.63 38.59-19.57 38.59-43.63-17.31-43.62-38.59-43.62m0 72.25c-13.01 0-23.59-12.84-23.59-28.62s10.58-28.62 23.59-28.62 23.59 12.84 23.59 28.62-10.58 28.62-23.59 28.62",
    style: {
      fill: "url(#humidity-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.14 371.68c0 24.05 17.31 43.62 38.59 43.62s38.59-19.57 38.59-43.62-17.31-43.62-38.59-43.62-38.59 19.57-38.59 43.62m38.58-28.63c13.01 0 23.59 12.84 23.59 28.62s-10.58 28.62-23.59 28.62-23.59-12.84-23.59-28.62 10.58-28.62 23.59-28.62",
    style: {
      fill: "url(#humidity-01_svg2__e)"
    }
  }));
};
export default SvgHumidity01;